import React from 'react'
import withFormState from 'src/components/aciacehighway/hocs/withFormState';
import { ScopedCssBaseline } from '@mui/material';
import EditTradePartner from '../component/trade-partner-form/edit/EditTradePartner';

function EditPage({ history, match: { params } }) {

  return (<ScopedCssBaseline>
    <EditTradePartner id={params.id} />
  </ScopedCssBaseline>);
}

export default withFormState(EditPage)
